import { Resizable } from "re-resizable";
import React, { useEffect, useState } from "react";
import { useWindowSize } from "rooks5";
import { Icon } from "../Icon";
import styles from "./styles.module.scss";

type Props = {
	open: boolean;
	onMinimize?: () => void;
	onMaximize?: () => void;
};

export const BottomPanel = ({
	open,
	onMinimize,
	onMaximize,
}: Props) => {
	const [height, setHeight] = useState(36);
	const { innerHeight: windowHeight } = useWindowSize();

	useEffect(() => {
		if (open) {
			setHeight((windowHeight as number) * 0.6);
		} else {
			setHeight(36);
		}
	}, [open]);

	return (
		<div className={styles.bottomPanelWrapper}>
			<Resizable
				minHeight="36px"
				maxHeight="60vh"
				enable={{ top: true }}
				size={{ height: height, width: "100%" }}
				onResizeStop={(event, direction, ref, delta) => {
					setHeight((h) => h + delta.height);
				}}
			>
				<div>
					<div className={styles.bottomPanelHeader}>
						<div className={styles.headerActions}>
							<button
								onClick={() => {
									onMinimize?.();
									setHeight(36);
								}}
								disabled={height === 36}
							>
								<Icon name="minimize" />
							</button>
							<button
								disabled={
									height === (windowHeight as number) * 0.6
								}
								onClick={() => {
									onMaximize?.();
									setHeight((windowHeight as number) * 0.6);
								}}
							>
								<Icon name="maximize" />
							</button>
						</div>
					</div>
				</div>
			</Resizable>
		</div>
	);
};
